import { api } from './apiInstances';

export const getNotificationASDS = async () => {
  const result = await api.get('/v1/SolicitudesServicioAutomatica/tiposNotificacion');

  return result.data;
};

// Obtener detalle de una ASDS
export const postCreateAutomaticServiceRequest = async (body) => {
  const response = await api.post('/v1/SolicitudesServicioAutomatica', body);

  return response.data;
};
